export const vueEditorToolbar = [
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" }
    ],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
];

export const minimalToolBar = [
    ["bold", "italic", "underline"],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }]
];

export const genders = [
    {
        "id": 1,
        "specificatif": "Masculin",
        "description": "Homme"
    },
    {
        "id": 2,
        "specificatif": "Féminin",
        "description": "Femme"
    }
];
